import { PRICING_API } from "@/constants";
import axios from "axios";

interface CoinGeckoPriceResponse {
  analog: {
    usd: number;
  };
}

const debounce = <T extends (...args: any[]) => any>(
  func: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const fetchANLOGPrice = async (): Promise<number> => {
  try {
    const response = await axios<CoinGeckoPriceResponse>({
      url: PRICING_API,
      method: "GET",
      params: {
        ids: "analog",
        vs_currencies: "usd",
      },
    });
    return response.data?.analog?.usd;
  } catch (error) {
    console.error("Error fetching ANLOG price:", error);
    return 0;
  }
};

// Debounced version of price fetching
export const debouncedFetchPrice = debounce(
  async (callback: (price: number) => void) => {
    const price = await fetchANLOGPrice();
    console.log("<<<price", price);
    callback(price);
  },
  500
); // 500ms debounce delay

export default {
  fetchANLOGPrice,
  debouncedFetchPrice,
};
